<template>
  <div>
    <!-- EDICION Y CREACION DE REQUERIMIENTOS EN VENTANA MODAL  -->
    <div v-if="dialog">
      <v-dialog class="elevation-0" v-model="dialog" width="100%" persistent transition="dialog-bottom-transition">
        <AdvanceDetail @close="dialog = false" :editData="editData" :serviceEdit="ServiceEdit" :isViewMode="selected.length > 0 &&
          selected[0].AdpStatus != 3 &&
          selected[0].AdpStatus != null
          ">
        </AdvanceDetail>
      </v-dialog>
    </div>

    <!-- LISTADO DE REQUERIMEINTOS POR TIPO   -->
    <v-row>
      <v-col style="padding-bottom: 0px">
        <!-- excel pdf @pdf="pdf()" -->
        <s-crud title="Adelanto de Productores" height="400px" ref="crudAdvanceProducer"
          @rowSelected="rowSelected($event)" search-input="" add-no-function :filter="filter" @add="add()"
          :edit="selected.length > 0 && selected[0].AdpStatus == 3" add @edit="edit()" :view="selected.length > 0 &&
            selected[0].AdpStatus != 3 &&
            selected[0].AdpStatus != null
            " :sync="selected.length > 0 &&
            [1, 8, 11].includes(selected[0].AdpStatus) &&
            (selected[0].TypeAdvance == 1 || selected[0].TypeAdvance == 2)
            " @sync="sendToSAP()" :remove="selected.length > 0" :config="config" delete-no-function
          @delete="deleteEvent($event)" pdf @pdf="pdf()">
          <!-- Filters Section -->
          <template v-slot:filter>
            <v-card class="filter-card mb-3" elevation="2">
              <v-card-title class="pa-1">
                <v-icon class="mr-3" color="primary">mdi-filter-variant</v-icon>
                <span class="text-h6 font-weight-medium">Filtros de Búsqueda</span>
                <v-spacer></v-spacer>
                <v-btn @click="clearFilters" color="grey" text small class="mr-2">
                  <v-icon small left>mdi-filter-off</v-icon>
                  Limpiar Filtros
                </v-btn>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="pa-2">
                <v-row align="end">
                  <v-col v-if="$fun.isAdmin()" lg="3" class="">
                    <s-select label="Usuario" placeholder="Digite Usuario" autocomplete clearable
                      item-text="NtpFullName" v-model="filter.UsrID" item-value="UsrID" :items="itemsUsers"
                      @input="selectedUsrID($event)"></s-select>
                  </v-col>
                  <v-col lg="3" class="">
                    <s-select-producer clearable autocomplete v-model="filter.PrdID" label="Productor">
                    </s-select-producer>
                  </v-col>
                  <v-col lg="2" cols="12" class="">
                    <s-date label="Fecha" clearable v-model="filter.BeginDate" />
                  </v-col>
                  <v-col lg="2" cols="12" class="">
                    <s-select-definition v-model="filter.AdpStatus" :def="1128" clearable label="Estado">
                    </s-select-definition>
                  </v-col>
                  <!-- <v-col lg="2" cols="12" class=""> 
                                        <s-date label="Fecha Fin" :clearable="clearableFilter"
                                            v-model="filter.EndDate" />
                                    </v-col> -->
                </v-row>
              </v-card-text>
            </v-card>
          </template>

          <!-- Template para ID con badge -->
          <template v-slot:item.AdpID="{ item }">
            <div color="primary" class="pa-0">#{{ item.AdpID }}</div>
          </template>

          <!-- Template para Fecha de Aplicación -->
          <template v-slot:item.ApplicationDate="{ item }">
            <span class="text-center font-weight-regular pa-0">
              {{ $fun.formatDateView(item.ApplicationDate) }}
            </span>
          </template>

          <template v-slot:item.TypeAdvance="{ item }">
            <span class="text-center font-weight-regular pa-0 d-inline-flex" style="gap: 4px">
              <v-icon :color="item.TypeAdvance == 2 ? 'dark' : 'green'">
                mdi {{ item.TypeAdvance == 2 ? "mdi-cash-check" : "mdi-leaf" }}
              </v-icon>
              {{ item.TypeAdvanceText }}
            </span>
          </template>

          <!-- Template para Nombre del Productor -->
          <template v-slot:item.PrdCardName="{ item }">
            <div class="text-start pa-0" style="min-width: 150px">
              {{ item.PrdCardName }}
            </div>
          </template>

          <!-- Template para Fundo -->
          <template v-slot:item.FagName="{ item }">
            <div class="d-inline-flex pa-0" style="min-width: 150px">
              <v-icon color="green">mdi-map-marker</v-icon>
              <span class="font-weight-regular text-start">{{
                item.FagName
              }}</span>
            </div>
          </template>

          <!-- Template para Campaña -->
          <template v-slot:item.CmpName="{ item }">
            <div class="campaign-cell pa-0">
              <v-icon small color="dark darken-1" class="">mdi-calendar-check</v-icon>
              <span class="font-weight-medium text-start">{{
                item.CmpName
              }}</span>
            </div>
          </template>

          <template v-slot:item.TotalAmount="{ item }">
            <span class="font-weight-medium">
              {{ formatDecimal(item.TotalAmount) }}
            </span>
          </template>

          <template v-slot:item.TotalAmountExchangeRate="{ item }">
            <span class="font-weight-medium">
              {{ formatDecimal(item.TotalAmountExchangeRate) }}
            </span>
          </template>

          <!-- Template para Justificación -->
          <template v-slot:item.AdpJustification="{ item }">
            <div class="text-start pa-0">
              {{ item.AdpJustification || "Sin justificación" }}
            </div>
          </template>

          <template v-slot:item.AdpStatusName="{ item }">
            <v-chip v-if="item.AdpStatus == null" x-small outlined color="orange"
              class="font-weight-regular white--text px-1 text-uppercase">
              REGISTRADO
            </v-chip>
            <v-chip v-else-if="
              item.AdpStatus == 3 ||
              item.AdpStatus == 9 ||
              item.AdpStatus == 12
            " x-small outlined color="red" class="font-weight-regular white--text px-1 text-uppercase">
              {{ item.AdpStatusName }}
            </v-chip>
            <v-chip v-else-if="
              item.AdpStatus == 1 ||
              item.AdpStatus == 8 ||
              item.AdpStatus == 11
            " x-small outlined color="green" class="font-weight-regular white--text px-1 text-uppercase">
              {{ item.AdpStatusName }}
            </v-chip>
            <v-chip v-else-if="item.AdpStatus == 4 || item.AdpStatus == 10" x-small outlined color="orange"
              class="font-weight-regular white--text px-1 text-uppercase">
              {{ item.AdpStatusName }}
            </v-chip>
            <v-chip v-else x-small outlined class="font-weight-regular grey--text px-1 text-uppercase">
              {{ item.AdpStatusName }}
            </v-chip>
          </template>

          <template v-slot:Attach="{ row }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small v-bind="attrs" v-on="on" outlined :color="row.AdpStatus === 1 ? 'blue darken-2' : 'grey'"
                  :disabled="row.AdpStatus !== 1" style="border-radius: 20px" @click="clickAttach(row)">
                  <v-icon left x-small>mdi-paperclip</v-icon>
                  Adjuntar
                </v-btn>
              </template>
              <span>Adjuntar archivos al adelanto</span>
            </v-tooltip>
          </template>
        </s-crud>
      </v-col>
    </v-row>

    <!--LISTADO DE DETALLE DE LOTES / FUNDOS-->
    <v-col style="padding: 0px; margin-top: 17px" cols="12" v-if="selected.length > 0">
      <s-toolbar label="Fundos Asociados"></s-toolbar>

      <!-- TABLA DETALLE DE LOTES -->
      <v-data-table dense :items="itemsFarmLots.filter((x) => x.ApfID > 0 && x.SecStatus === 1)"
        :headers="headersFarmLots" item-key="ApfID">
      </v-data-table>
    </v-col>

    <!--LISTADO DE   DETALLE DEL REQUERIMIENTO-->
    <v-col style="padding: 0px; margin-top: 17px" cols="12" v-if="selected.length > 0">
      <s-toolbar :remove="(itemsDetailSelect.length > 0
          ? itemsDetailSelect[0].SecStatus == 1
          : false) &&
        ($fun.isAdmin() ||
          itemsDetailSelect[0].UsrCreateID == $fun.getUserID())
        " label="Detalle de Ítems" @removed="removed(itemsDetailSelect)"></s-toolbar>

      <!-- TABLA DETALLE DE REQUERIMIENTO -->
      <v-data-table dense :items="itemsDetail" v-model="itemsDetailSelect" :headers="headersDetail" item-key="ApdID">
        <template v-slot:item.SubCategoryArticle="{ item }">
          <span class="text-center pa-0">
            {{
              item.TypeAdvance == 2
                ? item.TypeAdvanceText
                : item.SubCategoryArticle
            }}
          </span>
        </template>
        <template v-slot:item.Description="{ item }">
          <span class="text-start pa-0 text-uppercase">
            {{ item.TypeAdvance == 2 ? item.Description : item.Description }}
          </span>
        </template>
        <template v-slot:item.Quantity="{ item }">
          <div class="quantity-cell text-center pa-0">
            <span v-if="item.TypeAdvance == 2" class="font-weight-medium">
              {{ formatDecimal(item.Quantity) }}
            </span>
            <v-chip v-else small pill outlined color="primary" class="font-weight-medium">
              {{ item.Quantity }} {{ item.DedUnit }}
            </v-chip>
          </div>
        </template>
        <template v-slot:item.UnitPrice="{ item }">
          <div class="text-center pa-0">
            {{ formatDecimal(item.UnitPrice) }}
          </div>
        </template>
        <template v-slot:item.Total="{ item }">
          <div class="text-center pa-0 font-weight-bold">
            {{ formatDecimal(item.Total) }}
          </div>
        </template>
      </v-data-table>
    </v-col>

    <v-col style="padding: 0px; margin-top: 17px !important" class="mt-0 pt-0" lg="8" cols="6"
      v-if="selected.length > 0">
      <ApprovalLevelsDocument :DocEntry="selected[0].AdpID" :TypeObject="3" :key="approvalLevelsKey" />
    </v-col>

    <v-dialog v-if="dialogPdf && selected.length > 0" v-model="dialogPdf" width="70%">
      <advance-producer-pdf :advanceProducerSelected="dataPrint" @close="dialogPdf = false">
      </advance-producer-pdf>
    </v-dialog>

    <!-- ===== MODAL ADJUNTAR ARCHIVOS ===== -->
    <v-dialog v-model="dialogAttach" max-width="700px" persistent>
      <v-card>
        <!-- Header -->
        <v-card-title class="attach-dialog-header white--text pa-3">
          <v-icon color="white" class="mr-2">mdi-paperclip</v-icon>
          <span class="text-subtitle-1 font-weight-bold">Adjuntar Archivos</span>
          <v-spacer />
          <span v-if="attachAdpID" class="text-caption white--text opacity-75 mr-3">
            Adelanto #{{ attachAdpID }}
          </span>
          <v-btn icon small color="white" @click="closeAttachDialog">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4 pb-0">
          <!-- Formulario de agregar archivo -->
          <div class="dropzone mb-3 pa-3" @dragover.prevent="dragover = true" @dragleave.prevent="dragover = false"
            @drop.prevent="onDrop" :class="{ 'dropzone-active': dragover }">
            <v-row align="center">
              <v-col cols="12" sm="10">
                <v-file-input v-model="attachForm.files" label="Seleccione o arrastre los archivos aquí"
                  prepend-inner-icon="mdi-cloud-upload" prepend-icon="" hide-details show-size truncate-length="50"
                  multiple outlined dense />
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn color="blue darken-2" dark small block
                  :disabled="!attachForm.files || attachForm.files.length === 0" @click="addAttachToList">
                  <v-icon small left>mdi-plus</v-icon>
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <v-divider class="mb-2" />

          <!-- Lista de archivos a adjuntar -->
          <div class="attach-table-wrapper">
            <v-data-table :headers="attachHeaders" :items="attachList" dense hide-default-footer :items-per-page="-1"
              no-data-text="No se han agregado archivos aún" class="elevation-0">
              <template v-slot:item.fileName="{ item }">
                <div class="d-flex align-center">
                  <span class="text-caption text-truncate" style="max-width: 200px">
                    {{ item.fileName }}
                  </span>
                </div>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip x-small :color="item.status === 'pendiente' ? 'orange' : 'green'" dark>
                  {{ item.status === "pendiente" ? "Pendiente" : "Guardado" }}
                </v-chip>
              </template>
              <template v-slot:item.download="{ item }">
                <v-btn icon x-small color="blue darken-2" :disabled="item.status !== 'guardado'"
                  @click="openFile(item.fileName)">
                  <v-icon x-small>mdi-download</v-icon>
                </v-btn>
              </template>
              <template v-slot:item.actions="{ item, index }">
                <v-btn icon x-small color="red lighten-1" @click="deleteAttachment(item, index)">
                  <v-icon x-small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </div>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer />
          <v-btn text small color="grey darken-1" @click="closeAttachDialog">Cancelar</v-btn>
          <v-btn color="blue darken-2" dark small :loading="attachSaving" :disabled="attachList.filter((x) => x.status === 'pendiente').length === 0
            " @click="saveAttachments">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar Archivos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ===== MODAL SELECCIONAR BANCO ===== -->
    <v-dialog v-model="dialogBank" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline blue darken-2 white--text pa-3">
          <v-icon color="white" class="mr-2">mdi-bank</v-icon>
          <span class="text-subtitle-1 font-weight-bold">Seleccionar Banco</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-select
            v-model="selectedBank"
            :items="bankAccounts"
            item-text="DisplayName"
            item-value="FormatCode"
            label="Banco para la Transferencia"
            outlined
            dense
            :loading="loadingBanks"
          ></v-select>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn text small color="grey darken-1" @click="closeBankDialog">Cancelar</v-btn>
          <v-btn color="blue darken-2" dark small :disabled="!selectedBank" :loading="syncLoading" @click="confirmSyncSAP">
            <v-icon left small>mdi-check</v-icon>
            Confirmar Sincronización
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _AdvanceProducerService from "../../../services/Technicalassistance/AdvanceProducerService";
import _GenUploadFiles from "../../../services/General/GenUploadFiles";
import _sGeneral from "../../../services/HelperService";
import AdvanceDetail from "./AdvanceDetail.vue";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import ApprovalLevelsDocument from "@/views/Security/Circuit/Levels/ApprovalLevelsDocument";
import AdvanceProducerPdf from "./AdvanceProducerPdf.vue";

export default {
  name: "AdvanceProducer",
  components: {
    AdvanceDetail,
    AdvanceProducerPdf,
    SSelectProducer,
    ApprovalLevelsDocument,
    SSelectDefinition,
  },
  data: () => ({
    approvalLevelsKey: 0,
    isEditable: false,
    dialog: false,
    dialogPdf: false,
    dataPrint: [],
    selected: [],
    itemsDetail: [],
    itemsFarmLots: [],
    ServiceEdit: false,
    itemsDetailSelect: [],
    itemsUsers: [],
    AdvanceProducerEdit: {},
    // === Seleccionar Banco ===
    dialogBank: false,
    selectedBank: null,
    bankAccounts: [],
    loadingBanks: false,
    syncLoading: false,
    // === Adjuntar Archivos ===
    dialogAttach: false,
    attachAdpID: null,
    attachSaving: false,
    dragover: false,
    attachForm: {
      files: [],
    },
    attachList: [],
    attachHeaders: [
      { text: "Archivo", value: "fileName", sortable: false },
      { text: "Tamaño", value: "fileSize", sortable: false, width: 90 },
      {
        text: "Estado",
        value: "status",
        sortable: false,
        width: 90,
        align: "center",
      },
      {
        text: "Descargar",
        value: "download",
        sortable: false,
        width: 80,
        align: "center",
      },
      {
        text: "",
        value: "actions",
        sortable: false,
        width: 40,
        align: "center",
      },
    ],
    filter: {
      UsrID: null,
      PrdID: null,
      BeginDate: "",
      AdpStatus: null,
    },
    config: {
      model: {
        AdpID: "ID",
        ApplicationDate: "datetime",
        SecUpdate: "datetime",
        IncludesTax: "int",
      },
      service: _AdvanceProducerService,
      headers: [
        { text: "ID", value: "AdpID", sortable: false, width: 40 },
        {
          text: "Estado",
          value: "AdpStatusName",
          width: 60,
          sortable: false,
          align: "center",
        },
        {
          text: "N° Requerimiento",
          value: "AdpDocumentNumber",
          sortable: false,
          width: 40,
        },
        {
          text: "Fecha",
          value: "ApplicationDate",
          sortable: false,
          width: 60,
          align: "center",
        },
        {
          text: "Adelanto",
          value: "TypeAdvance",
          sortable: false,
          width: 60,
          align: "center",
        },
        // { text: "Fundo", value: "FagName", sortable: false, align: "center" },
        // { text: "Lote", value: "FltName", sortable: false, width: 80, align: "center" },
        {
          text: "Campaña",
          value: "CmaName",
          sortable: false,
          width: 140,
          align: "center",
        },
        {
          text: "Productor",
          value: "ProducerName",
          sortable: false,
          width: 300,
          align: "center",
        },
        {
          text: "Moneda",
          value: "TypeCurrencyName",
          sortable: false,
          width: 45,
          align: "center",
        },
        {
          text: "Tipo de Cambio",
          value: "ExchangeRate",
          sortable: false,
          width: 45,
          align: "center",
        },
        {
          text: "Total",
          value: "TotalAmount",
          sortable: false,
          width: 80,
          align: "center",
        },
        {
          text: "Total Soles",
          value: "TotalAmountExchangeRate",
          sortable: false,
          width: 80,
          align: "center",
        },
        {
          text: "Documento SAP",
          value: "DocNumSAP",
          sortable: false,
          width: 50,
          align: "center",
        },
        {
          text: "Justificación",
          value: "AdpJustification",
          sortable: false,
          width: 200,
          align: "center",
        },
        // { text: "Registrado", value: "SecCreate", width: 60, sortable: false, align: "center" },

        // { text: "Responsable de Cobro", value: "PrdCardCodeRcFullName", width: 160, sortable: false },
        { text: "Adjuntar Archivos", value: "Attach", width: 10 },
      ],
    },
    headersFarmLots: [
      { text: "ID", value: "FltID", sortable: false, align: "center" },
      { text: "Fundo", value: "FagName", sortable: false, align: "center" },
      { text: "Lote", value: "FltName", sortable: false, align: "center" },
      {
        text: "Responsable de Cobro",
        value: "ResponsibleCollectingFarmLot",
        sortable: false,
        align: "center",
      },
      {
        text: "Tipo de Cultivo",
        value: "TypeCultiveText",
        sortable: false,
        align: "center",
      },
    ],
    headersDetail: [
      {
        text: "ID",
        value: "ApdID",
        sortable: false,
        align: "center",
        width: 60,
      },
      {
        text: "Categoría",
        value: "ItmsGrpNam",
        width: 250,
        align: "center",
        sortable: false,
      },
      { text: "Descripción", value: "Description", sortable: false },
      {
        text: "Cantidad",
        value: "Quantity",
        sortable: false,
        width: 100,
        align: "center",
      },
      {
        text: "Precio",
        value: "UnitPrice",
        sortable: false,
        width: 100,
        align: "center",
      },
      {
        text: "Importe",
        value: "Total",
        sortable: false,
        width: 100,
        align: "center",
      },
    ],
  }),
  watch: {
    dialog(val) {
      this.$refs.crudAdvanceProducer.refresh();
      if (!val) {
        if (this.selected && this.selected.length > 0) {
          this.rowSelected(this.selected);
          this.approvalLevelsKey += 1;
        }
      }
    },
  },
  methods: {
    deleteEvent(item) {
      item.AdpStatus = 6;

      this.$fun.alert("¿Eliminar el registro?", "question").then((result) => {
        if (result.value) {
          _AdvanceProducerService
            .save(item, this.$fun.getUserID())
            .then((res) => {
              if (res.status == 200) {
                this.$fun.alert(
                  "Se eliminó correctamente el registro.",
                  "success",
                );
                this.$refs.crudAdvanceProducer.refresh();
                this.selected = [];
                this.itemsDetail = [];
                this.itemsFarmLots = [];
              }
            });
        }
      });
    },
    rowSelected(item) {
      if (item == null || item.length == 0) return;
      this.selected = item;
      // console.log(this.selected);
      const requestID = this.$fun.getUserID();
      const parametersPagination = {
        filter: {},
        draw: 1,
        start: 0,
        length: 10,
        order: [{ dir: "asc", column: "" }],
        searchText: "",
      };
      _AdvanceProducerService
        .getAdvanceProducerDetails(
          parametersPagination,
          item[0].AdpID,
          requestID,
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.itemsDetail = data;
            // console.log(this.itemsDetail);
          }
        });
      _AdvanceProducerService
        .getAdvanceProducerFarmLots(
          parametersPagination,
          item[0].AdpID,
          requestID,
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.itemsFarmLots = data;
          }
        });
    },
    add() {
      this.selected = [];
      this.editData = {};
      this.dialog = true;
    },
    edit() {
      if (this.selected.length > 0) {
        console.log("this.selected[0]", this.selected[0]);
        this.editData = this.selected[0];
        this.editData.AdvanceProducerDetail = this.itemsDetail;
        this.editData.AdvanceProducerFarmLot = this.itemsFarmLots;
        console.log("this.editData", this.editData);
        this.dialog = true;
      }
    },
    selectedUsrID() { },
    clearFilters() {
      this.filter = {
        UsrID: parseInt(this.$fun.getUserID()),
        PrdID: null,
        BeginDate: "",
      };
    },
    sendToSAP() {
      if (this.selected.length === 0) return;
      let adpID = this.selected[0].AdpID;
      let isCash = this.selected[0].TypeAdvance === 2;

      if (isCash) {
        // Cargar bancos y abrir diálogo modal
        this.selectedBank = null;
        this.dialogBank = true;
        this.loadingBanks = true;
        _AdvanceProducerService
          .getBankAccounts(this.$fun.getUserID())
          .then((res) => {
            let currencyId = this.selected[0].TypeCurrency;
            let accounts = res.data || [];

            // Filtrar por tipo de moneda del adelanto
            if (currencyId === 1) {
              // Soles
              accounts = accounts.filter(x => {
                let curr = (x.ActCurr || "").toUpperCase().trim();
                return curr === "SOL" || curr === "PEN" || curr === "S/" || curr === "##" || curr === "";
              });
            } else if (currencyId === 2) {
              // Dólares
              accounts = accounts.filter(x => {
                let curr = (x.ActCurr || "").toUpperCase().trim();
                return curr === "USD" || curr === "US$" || curr === "##" || curr === "";
              });
            } else if (currencyId === 4) {
              // Euros
              accounts = accounts.filter(x => {
                let curr = (x.ActCurr || "").toUpperCase().trim();
                return curr === "EUR" || curr === "EUR$" || curr === "##" || curr === "";
              });
            }

            this.bankAccounts = accounts.map(x => ({
              ...x,
              DisplayName: `${x.FormatCode} - ${x.AcctName}`
            }));
          })
          .catch((err) => {
            console.log("Error al cargar bancos", err);
            // Fallback manual en caso de error
            let currencyId = this.selected[0].TypeCurrency;
            let fallbackList = [
              { FormatCode: "1041101", AcctName: "Ctas Ctes Oper S/ - BCP", ActCurr: "SOL" },
              { FormatCode: "1041102", AcctName: "Ctas Ctes Oper S/ - BBVA", ActCurr: "SOL" },
              { FormatCode: "1041103", AcctName: "Ctas ctes oper S/ - Bco Interbank", ActCurr: "SOL" },
              { FormatCode: "1041117", AcctName: "Ctas ctes oper S/ - Bco Santander", ActCurr: "SOL" }
            ];

            if (currencyId === 1) {
              fallbackList = fallbackList.filter(x => x.ActCurr === "SOL");
            } else if (currencyId === 2) {
              fallbackList = fallbackList.filter(x => x.ActCurr === "USD");
            } else if (currencyId === 4) {
              fallbackList = fallbackList.filter(x => x.ActCurr === "EUR");
            }

            this.bankAccounts = fallbackList.map(x => ({
              ...x,
              DisplayName: `${x.FormatCode} - ${x.AcctName}`
            }));
          })
          .finally(() => {
            this.loadingBanks = false;
          });
      } else {
        // Sincronización directa para insumos
        let confirmMessage = "¿Sincronizar con SAP las OVs?";
        let successMessage = "Se sincronizaron correctamente las OVs en SAP.";

        this.$fun
          .alert(confirmMessage, "question")
          .then((result) => {
            if (result.value) {
              _AdvanceProducerService
                .syncSAP(adpID, this.$fun.getUserID())
                .then((res) => {
                  if (res.status === 200 && res.data.success) {
                    this.$fun.alert(successMessage, "success");
                    this.$refs.crudAdvanceProducer.refresh();
                    if (this.selected && this.selected.length > 0) {
                      this.rowSelected(this.selected);
                      this.approvalLevelsKey += 1;
                    }
                  } else {
                    this.$fun.alert(
                      "No se pudo sincronizar: " +
                      (res.data.message || "Error desconocido"),
                      "error"
                    );
                  }
                })
                .catch((err) => {
                  console.log("Error al sincronizar con SAP", err);
                });
            }
          });
      }
    },
    confirmSyncSAP() {
      if (this.selected.length === 0 || !this.selectedBank) return;
      let adpID = this.selected[0].AdpID;
      this.syncLoading = true;

      _AdvanceProducerService
        .syncSAP(adpID, this.$fun.getUserID(), this.selectedBank)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            this.$fun.alert("Se sincronizó correctamente el Pago Efectuado en SAP.", "success");
            this.dialogBank = false;
            this.$refs.crudAdvanceProducer.refresh();
            if (this.selected && this.selected.length > 0) {
              this.rowSelected(this.selected);
              this.approvalLevelsKey += 1;
            }
          } else {
            this.$fun.alert(
              "No se pudo sincronizar: " +
              (res.data.message || "Error desconocido"),
              "error"
            );
          }
        })
        .catch((err) => {
          console.log("Error al sincronizar con SAP", err);
          this.$fun.alert("Error de red o de servidor al sincronizar.", "error");
        })
        .finally(() => {
          this.syncLoading = false;
        });
    },
    closeBankDialog() {
      this.dialogBank = false;
    },
    pdf() {
      _AdvanceProducerService
        .byID({ AdpID: this.selected[0].AdpID }, this.$fun.getUserID())
        .then((res) => {
          if (res.status == 200) {
            this.dataPrint = res.data;
            this.dialogPdf = true;
          }
        });
    },
    formatDecimal(value) {
      if (value === null || value === undefined) return "";
      return new Intl.NumberFormat("es-PE", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    // ===== Adjuntar Archivos =====
    clickAttach(row) {
      this.attachAdpID = row.AdpID;
      this.attachForm = { files: [] };
      this.dialogAttach = true;
      this.loadAttachments(row.AdpID);
    },
    closeAttachDialog() {
      this.dialogAttach = false;
      this.attachAdpID = null;
      this.attachList = [];
      this.attachForm = { files: [] };
    },

    async loadAttachments(AdpID) {
      this.attachLoading = true;
      try {
        const res =
          await _AdvanceProducerService.listTasAdvanceProducerAttachment(
            AdpID,
            this.$fun.getUserID(),
          );
        if (res.status === 200) {
          this.attachList = res.data.map((item) => ({
            ApaID: item.ApaID,
            AdpID: item.AdpID,
            DedValue: null,
            DedDescription: "",
            fileName: item.FilePath,
            fileSize: "-",
            status: "guardado",
          }));
        }
      } finally {
        this.attachLoading = false;
      }
      // this.attachList = [];
    },

    addAttachToList() {
      const { files } = this.attachForm;
      if (!files || files.length === 0) {
        this.$fun.alert("Seleccione al menos un archivo", "warning");
        return;
      }

      let duplicados = 0;

      files.forEach((file) => {
        // Validación para evitar duplicados
        const exists = this.attachList.some(
          (item) => item.fileName === file.name,
        );
        if (exists) {
          duplicados++;
          return; // saltar este archivo
        }

        const sizeKB = (file.size / 1024).toFixed(1);
        this.attachList.push({
          ApaID: 0,
          AdpID: this.attachAdpID,
          DedValue: null,
          DedDescription: "",
          fileName: file.name,
          fileSize: sizeKB + " KB",
          file,
          status: "pendiente",
        });
      });

      if (duplicados > 0) {
        this.$fun.alert(
          `${duplicados} archivo(s) ya se encontraban en la lista y fueron omitidos.`,
          "info",
        );
      }

      this.attachForm.files = [];
    },

    async onDrop(e) {
      this.dragover = false;
      const items = e.dataTransfer.items;

      if (items && items.length > 0) {
        const files = [];
        const promises = [];

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.kind === "file") {
            const entry = item.webkitGetAsEntry
              ? item.webkitGetAsEntry()
              : null;
            if (entry) {
              promises.push(this.traverseFileTree(entry, files));
            } else {
              files.push(item.getAsFile());
            }
          }
        }

        await Promise.all(promises);

        if (files.length > 0) {
          this.attachForm.files = files;
          this.addAttachToList();
        }
      } else if (e.dataTransfer.files.length > 0) {
        this.attachForm.files = Array.from(e.dataTransfer.files);
        this.addAttachToList();
      }
    },

    traverseFileTree(item, filesArr) {
      return new Promise((resolve) => {
        if (item.isFile) {
          item.file((file) => {
            filesArr.push(file);
            resolve();
          });
        } else if (item.isDirectory) {
          const dirReader = item.createReader();
          dirReader.readEntries(async (entries) => {
            const promises = [];
            for (let i = 0; i < entries.length; i++) {
              promises.push(this.traverseFileTree(entries[i], filesArr));
            }
            await Promise.all(promises);
            resolve();
          });
        } else {
          resolve();
        }
      });
    },

    removeAttachFromList(index) {
      this.attachList.splice(index, 1);
    },

    async saveAttachments() {
      const pending = this.attachList.filter((x) => x.status === "pendiente");
      if (pending.length === 0) {
        this.$fun.alert("No hay archivos pendientes por guardar", "info");
        return;
      }

      this.attachSaving = true;
      try {
        // 1. Subir archivos físicos nuevos (ApaID === 0) al servidor
        const newFiles = pending.filter((x) => x.ApaID === 0 && x.file);
        if (newFiles.length > 0) {
          const formData = new FormData();
          newFiles.forEach((row, index) => {
            formData.append(index.toString(), row.file);
          });

          const uploadRes = await _sGeneral.uploadfile(
            "AdvanceProducer",
            this.$fun.getUserID(),
            formData,
            3,
          );

          if (uploadRes.status !== 200) {
            this.$fun.alert("Error al subir los archivos", "warning");
            return;
          }
        }

        // 2. Guardar metadatos en el backend
        const AdvanceProducerAttachment = this.attachList.map((row) => ({
          ApaID: row.ApaID,
          AdpID: row.AdpID,
          TypeAttachment: null,
          FilePath: row.fileName,
          SecStatus: 1,
          UsrCreateID: this.$fun.getUserID(),
        }));

        const r = await _AdvanceProducerService.saveListAttachment(
          AdvanceProducerAttachment,
          this.$fun.getUserID(),
        );

        const esSuccess =
          r &&
          (r.status === 200 ||
            r.status === 201 ||
            r.status === 204 ||
            !r.status);

        if (esSuccess) {
          this.$fun.alert("Archivos Guardados Correctamente", "success");
          this.closeAttachDialog();
        }
      } catch (err) {
        console.error("Error al guardar adjuntos", err);
        this.$fun.alert("Ocurrió un error al guardar los archivos", "warning");
      } finally {
        this.attachSaving = false;
      }
    },
    openFile(nameFile) {
      console.log("Imprime :", nameFile);
      _sGeneral.download(nameFile, this.$fun.getUserID()).then((r) => {
        if (r.status === 200) {
          this.$fun.download(r.data, nameFile);
        }
      });
    },
    async deleteAttachment(item, index) {
      const confirm = await this.$fun.alert(
        "¿Desea eliminar este archivo adjunto?",
        "question",
      );
      if (!confirm.value) return;

      // Si es pendiente (no guardado aún), solo quitar de la lista
      if (!item.ApaID || item.ApaID === 0) {
        this.attachList.splice(index, 1);
        return;
      }

      // Si ya está guardado, llamar al servicio para desactivarlo
      try {
        const usrID = this.$fun.getUserID();
        const obj = {
          ApaID: item.ApaID,
          AdpID: item.AdpID,
          TypeAttachment: item.DedValue,
          FilePath: item.fileName,
          SecStatus: 0,
          UsrCreateID: usrID,
        };
        const res = await _AdvanceProducerService.saveListAttachment(
          [obj],
          usrID,
        );
        if (res && (res.status === 200 || res.status === 204)) {
          this.attachList.splice(index, 1);
          this.$fun.alert("Archivo eliminado correctamente", "success");
        } else {
          this.$fun.alert("No se pudo eliminar el archivo", "warning");
        }
      } catch (e) {
        console.error("Error al eliminar adjunto:", e);
        this.$fun.alert("Error al eliminar el archivo", "warning");
      }
    },

    downloadAttach(item) {
      if (item.savedFileName || item.fileName) {
        _GenUploadFiles
          .getFile("PathAdvanceProducer", item.savedFileName || item.fileName)
          .catch((e) => console.error("Error al descargar archivo:", e));
      }
    },

    fileIcon(fileName) {
      if (!fileName) return "mdi-file";
      const ext = fileName.split(".").pop().toLowerCase();
      if (ext === "pdf") return "mdi-file-pdf-box";
      if (["xls", "xlsx"].includes(ext)) return "mdi-file-excel";
      if (["doc", "docx"].includes(ext)) return "mdi-file-word";
      if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "mdi-file-image";
      return "mdi-file";
    },

    fileIconColor(fileName) {
      if (!fileName) return "grey";
      const ext = fileName.split(".").pop().toLowerCase();
      if (ext === "pdf") return "red darken-2";
      if (["xls", "xlsx"].includes(ext)) return "green darken-2";
      if (["doc", "docx"].includes(ext)) return "blue darken-2";
      if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "teal";
      return "grey";
    },
  },
  created() {
    // this.filter.UsrID = parseInt(this.$fun.getUserID());
    var objPers = {};
    if (this.$fun.isAdmin()) {
      objPers.AreID = null;
      _AdvanceProducerService
        .users(objPers, this.$fun.getUserID())
        .then((r) => {
          this.itemsUsers = r.data;
          this.filter.UsrID = parseInt(this.$fun.getUserID());
        });
    }
  },
};
</script>

<!-- ESTILOS CSS ADICIONALES PARA LOS TEMPLATES -->
<style scoped>
.producer-info {
  text-align: start;
}

.campaign-cell {
  display: flex;
  align-items: center;
}

.input-type-cell {
  display: flex;
  align-items: center;
}

/* Modal de adjuntar archivos */
.dropzone {
  border: 2px dashed #b0bec5;
  border-radius: 8px;
  background-color: #f5f7fa;
  transition: all 0.3s ease;
}

.dropzone-active {
  border-color: #1976d2;
  background-color: #e3f2fd;
}

.attach-dialog-header {
  background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%);
  border-radius: 4px 4px 0 0;
}

.attach-table-wrapper {
  min-height: 120px;
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
</style>
